import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { StarIcon } from "@phosphor-icons/react";
import { toast } from "sonner";
import { fetchBuilderFollows, toggleBuilderFollow } from "../lib/api";
import { getClientId } from "../lib/clientId";

export const FollowBuilderButton = ({ creator, size = "md", labels = ["Follow builder", "Following"] }) => {
  const cid = getClientId();
  const qc = useQueryClient();

  const { data } = useQuery({
    queryKey: ["builderFollows", cid],
    queryFn: () => fetchBuilderFollows(cid),
    staleTime: 30000,
  });
  const following = (data?.creators || []).includes(creator);

  const mut = useMutation({
    mutationFn: () => toggleBuilderFollow(cid, creator),
    onSuccess: (res) => {
      qc.setQueryData(["builderFollows", cid], { creators: res.creators });
      qc.invalidateQueries({ queryKey: ["provenBuilders"] });
      toast.success(res.following ? "Following builder — their launches pin to the top." : "Unfollowed builder.");
    },
    onError: () => toast.error("Couldn't update. Try again."),
  });

  if (!creator) return null;
  const pad = size === "sm" ? "px-2 py-1 text-[10px]" : "px-3 py-1.5 text-xs";

  return (
    <button
      data-testid={`follow-builder-${creator}`}
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); mut.mutate(); }}
      disabled={mut.isPending}
      className={`inline-flex items-center gap-1.5 font-semibold border transition-colors disabled:opacity-50 ${pad} ${
        following ? "border-neon/60 bg-neon/10 text-neon" : "border-white/20 text-muted-foreground hover:border-neon/50 hover:text-neon"
      }`}
      title={following ? "Unfollow this deployer" : "Follow this deployer — pin their launches to the top of Proven Builders"}
    >
      <StarIcon size={size === "sm" ? 12 : 14} weight={following ? "fill" : "regular"} />
      {following ? labels[1] : labels[0]}
    </button>
  );
};
